import { toggleList } from '@platejs/list-classic';
import {
  BulletedListPlugin,
  ListItemPlugin,
  ListPlugin,
  NumberedListPlugin,
} from '@platejs/list-classic/react';
import { useEditorState, type PlateElementProps } from 'platejs/react';

import OrderedListIcon from '../../../../../icons/ordered-list.svg?react';
import UnorderedListIcon from '../../../../../icons/unordered-list.svg?react';
import { ToolbarBlockButton } from '../../ToolbarBlockButton';

export const listPlugin = ListPlugin;

const Ul = ({ attributes, children }: PlateElementProps) => (
  <ul style={{ paddingLeft: 20 }} {...attributes}>
    {children}
  </ul>
);

const Ol = ({ attributes, children }: PlateElementProps) => (
  <ol style={{ paddingLeft: 20 }} {...attributes}>
    {children}
  </ol>
);

const Li = ({ attributes, children }: PlateElementProps) => (
  <li {...attributes}>{children}</li>
);

export const listComponents = {
  [BulletedListPlugin.key]: Ul,
  [NumberedListPlugin.key]: Ol,
  [ListItemPlugin.key]: Li,
};

export const ListToolbarButtons = ({
  bulletedListLabel = 'Bulleted list',
  numberedListLabel = 'Numbered list',
}: {
  bulletedListLabel?: string;
  numberedListLabel?: string;
}) => {
  const editor = useEditorState();

  return (
    <>
      <ToolbarBlockButton
        aria-label={bulletedListLabel}
        icon={UnorderedListIcon}
        type={BulletedListPlugin.key}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();

          toggleList(editor, { type: BulletedListPlugin.key });
          editor.tf.focus();
        }}
      />
      <ToolbarBlockButton
        aria-label={numberedListLabel}
        icon={OrderedListIcon}
        type={NumberedListPlugin.key}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();

          toggleList(editor, { type: NumberedListPlugin.key });
          editor.tf.focus();
        }}
      />
    </>
  );
};
